<template>
    <div class="flex flex-col flex-auto min-w-0 px-26px pt-7 pb-6 gap-4">
        <div class="flex-auto">
            <div>
                <img src="@/assets/icon/ic-nodata-claim-history.png" class="mx-auto img-icon" alt=""/>
            </div>
            <div class="text-a-gray-afafaf font-medium text-21 leading-8 text-center -mt-6">
                ไม่พบประวัติการเคลม
            </div>
            <div class="mt-5 text-center text-12 font-light text-a-gray-afafaf line-height-18">
                <div>หากพบปัญหาการใช้งาน</div>
                <div>ติดต่อศูนย์บริการลูกค้า ธนชาตประกันภัย</div>
                <a href="tel:1519" class="text-a-orange-fe5000 font-medium text-12 underline">โทร. 1519</a>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    setup: function () {
    },
})
</script>

<style lang="scss" scoped>
.text-21 {
    font-size: 21px;
}

.line-height-18 {
    line-height: 18px;
}
.img-icon{
    max-height: 280px;
}
</style>
